// @ts-nocheck
import React from 'react';
import { Box, Grid, Typography, Checkbox, Tooltip } from '@mui/material';
import GenericToolTip from 'components/__v2__/GenericToolTip';
import { HelpIcon } from 'pages/Forms/RegisterForm/CustomFormBuilder/config/constantSvg';
import { useAttachmentStyles } from '../style';
import { fileFormats } from '../constants';
import FileTypeIcon from './FileIconType';
import FileActions from './FileActions';

const FileAttachment = ({ fileAttach, setFileAttach, handleDirty, field }) => {
  const classes = useAttachmentStyles();
  const handleAttachToPdfChange = (fileId) => (event) => {
    const updatedFileAttach = fileAttach.map((file) =>
      file.id === fileId
        ? { ...file, attach_to_pdf: event.target.checked }
        : file,
    );
    setFileAttach(updatedFileAttach);
  };
  const helpIconStyle = { paddingLeft: '5px' };

  const renderFiles = () =>
    fileAttach
      ?.filter((file) =>
        fileFormats?.includes(file?.name?.split('.')?.pop()?.toLowerCase()),
      )
      ?.map((file) => (
        <Box key={file?.id} className={classes.attachmentsContainer}>
          <Box>
            <Box className={classes.attachmentIcon}>
              <FileTypeIcon
                fileType={file?.name?.split('.', 2)[1]}
                classes={classes}
              />
            </Box>
            <Box className={classes.attachment}>
              <p className={classes.fileName}>
                <GenericToolTip title={file?.name} char={20}>
                  {file?.name}
                </GenericToolTip>
              </p>
            </Box>
            <FileActions
              file={file}
              fileAttach={fileAttach}
              setFileAttach={setFileAttach}
              classes={classes}
              handleDirty={handleDirty}
            />
          </Box>

          {file.mime_type === 'pdf' && field.type === 'instruction' && (
            <Grid mt={1} display="flex" alignItems="center">
              <Grid ml={-1}>
                <Checkbox
                  size="small"
                  checked={file.attach_to_pdf}
                  onChange={handleAttachToPdfChange(file.id)}
                />
              </Grid>
              <Typography variant="subtitle2" color="inherit">
                Attach in response pdf
              </Typography>
              <Tooltip
                title="Ensure this document is attached to the response Pdf when downloading the submitted response."
                placement="top"
              >
                <span style={helpIconStyle}>{HelpIcon}</span>
              </Tooltip>
            </Grid>
          )}
        </Box>
      ));

  return renderFiles();
};

export default FileAttachment;
